import React from 'react'

const MainSaasLoader = () => {
  return (
    <div className="animate-pulse space-y-4">
    <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-1/4"></div>
    <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-3/4"></div>
    <div className="h-48 bg-gray-300 dark:bg-gray-700 rounded mt-4"></div>
  </div>
  )
}

export default MainSaasLoader